module.exports = __webpack_public_path__ + "img/job-location.dfa6dfe1.svg";